import client from '../../client';

const DOCUMENT_TYPES = {
  getDocumentTypes(params) {
    return client.get('/document_types', params)
  }
}

export default DOCUMENT_TYPES;
